// extracted by mini-css-extract-plugin
module.exports = {"form":"EditTimeTableForm_form__bKMRH","container":"EditTimeTableForm_container__okc8s","rowsContainer":"EditTimeTableForm_rowsContainer__1daK9"};